import { getPermissionsForCoreUploadTypes } from '@repo/csv'
import { createFileRoute } from '@tanstack/react-router'
import { AUTO_INJECT_UPLOAD_TYPES } from './-upload-types'

export const Route = createFileRoute('/_auth/_modules/_app/core-upload-data/auto-inject')({
  staticData: {
    title: 'route.coreUploadData.autoInject',
    crumb: 'route.coreUploadData.autoInject',
    permissions: getPermissionsForCoreUploadTypes(AUTO_INJECT_UPLOAD_TYPES),
  },
  beforeLoad: async ({ context }) => {
    context.handleRoutePermissions(Route, { atLeastOne: true })
  },
})
